addEventListener('turbo:before-cache', () => {
	const modal = document.querySelector('#turbo-modal')
	modal.innerHTML = ''
	modal.removeAttribute('src')

	const modal_backdrop = document.querySelectorAll('.modal-backdrop')
	modal_backdrop.forEach(element => element.remove())
})
